export const environment = {
  production: false,
  name: 'Test Environment',
  apiUrl: 'https://websdktest.turkcell.com.tr',
  //version: require('../../package.json').version,
  contractUrl: 'https://omccstb.turkcell.com.tr/tpay/paycell/',
  version: '1.0.0_38'
};
